import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Common
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { AddUserIcon } from '$common/icons'
import { RemoveIcon } from '$common/icons/remove'
// Logic
import { useRoom } from '$logic/room/react-hook'
import { addMembers, permitBannedUsers } from '$logic/subscription'
import { removeFromOpenedUserList } from '$logic/opened-user-list'
import { t } from '$i18n'

interface Props {
  roomId: string
  userId: string
  isOpen: boolean
}

export function RemovedUserMenu({ userId, roomId, isOpen }: Props) {
  const room = useRoom(roomId)
  const isGroup = room.type === 'GROUP'
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={
          isGroup
            ? t('menu.removedUser.addToGroup')
            : t('menu.removedUser.addToChannel')
        }
        onClick={async () => {
          analite('CHAT_ADD_MEMBER', {
            type: room.type,
            source: 'REMOVED_USER_MENU',
          })
          await addMembers(roomId, [userId])
          removeFromOpenedUserList(userId)
          await closeCurrentModal()
        }}
      >
        <AddUserIcon />
      </PopupMenuItem>

      <PopupMenuItem
        text={t('menu.removedUser.delete')}
        onClick={async () => {
          await permitBannedUsers(roomId, [userId])
          removeFromOpenedUserList(userId)
          await closeCurrentModal()
        }}
        error
      >
        <RemoveIcon sx={{ color: 'error.main' }} />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
